<template>
    <div>
        <Form @submit="submit">
            <Field
                    :class="disabledUnit?'disabled':''"
                    :disabled="disabledUnit"
                    clearable
                    v-model="detail.unitName"
                    label="所属单位"
                    placeholder="请选择所属单位"
                    required
                    readonly
                    right-icon="arrow-down"
                    @click="disabledUnit?'':unitPanel=true"
                    :rules="[{ required: true, message: '所属单位必填' }]"
            />
            <Field
                    clearable
                    v-model="detail.levelName"
                    label="隐患等级"
                    placeholder="请选择隐患等级"
                    required
                    readonly
                    right-icon="arrow-down"
                    @click="levelPanel=true"
                    :rules="[{ required: true, message: '隐患等级必填' }]"
            />
            <Field
                    clearable
                    v-model="detail.content"
                    label="隐患内容"
                    required
                    placeholder="请输入隐患内容"
                    :rules="[{ required: true, message: '隐患内容必填' }]"
            />
            <Field
                    clearable
                    v-model="detail.remark"
                    label="隐患备注"
                    required
                    :rules="[{ required: true, message: '隐患备注必填' }]"
                    placeholder="请输入备注"
            />
            <Field
                    clearable
                    label="隐患照片"
                    style="display: block"
            >
                <UploadImage
                        slot="input"
                        :imageList="detail.fileIdList"
                        type="DangerImage"
                        :count="4" edit
                        @imageChange="imageChange"
                />
            </Field>
            <div v-if="detailId == null">
                <!--<pf code="detail_ADD">-->
                <Button type="info" block style="width: 95% ; margin: 10px auto;" native-type="submit">保存</Button>
                <!--</pf>-->
            </div>
            <div v-else>
                <!--<pf code="DEVICE_EDIT">-->
                <Button type="info" block style="width: 95% ; margin: 10px auto;" native-type="submit">保存</Button>
                <!--</pf>-->
            </div>
        </Form>
        <SelectTreePopup :show="unitPanel" :defaultSelected="detail.unitId?{id:detail.unitId,name:detail.unitName}:{}"
                         :treeData="unitList"
                         :defaultTitle="detail.unitName||'选择单位'" @ok="onUnitOk" @cancel="onUnitCancel"/>
        <SelectDict dictKey="UNIT_DANGER_LEVEL" :show="levelPanel"
                    @cancel="levelPanel=false" @ok="onLevelOk"/>

    </div>
</template>

<script>
    import {Button, Field, Form} from "vant";
    import SelectTreePopup from "@/components/SelectPopup/SelectTreePopup"
    import UploadImage from "@/components/UploadImage";
    import WeChatIcon from "@/components/Icon/WeChatIcon";
    import SelectDict from "@/components/SelectPopup/SelectDict";
    import {mapGetters} from 'vuex'

    export default {
        components: {
            Form, Field, UploadImage, Button,
            SelectTreePopup, WeChatIcon, SelectDict
        },
        props: {},
        data() {
            return {
                detailId: this.$route.params.id,
                source: this.$route.params.source,
                detail: {
                    content: '',
                    unitId: '',
                    unitName: '',
                    level: '',
                    levelName: '',
                    fileIdList: [],
                    remark: ''
                },
                unitPanel: false,
                levelPanel: false,
            }
        },
        computed: {
            disabledUnit() {
                return this.detailId || this.isTask
            },
            isTask() {
                return 'PROSPECT' === this.source
            },
            ...mapGetters({unitList: 'global/unitList'})
        },
        created() {
            if (this.detailId == null) {
                this.$initUnit(this.detail)
            }
        },
        mounted() {
            if (this.detailId != null) {
                this.getDetail();
            }
            if (this.isTask) {
                this.getTaskDetail();

            }
        },
        methods: {
            onLevelOk(data) {
                this.detail.levelName = data.codeName;
                this.detail.level = data.code;
                this.levelPanel = false;
            },
            changeUnit(unit) {
                this.detail.unitId = unit.id;
                this.detail.unitName = unit.name;
            },
            onUnitCancel() {
                this.unitPanel = false;
            },
            onUnitOk(data) {
                this.onUnitCancel()
                this.changeUnit(data)
            },

            getDetail() {
                this.$http.tokiot.safety.danger.get({id: this.detailId})
                    .then(res => {
                        if (res) {
                            this.detail = res;
                        }
                    })
            },
            getTaskDetail() {
                this.$http.tokiot.prospect.task.get({id: this.$route.params.prospectTaskId})
                    .then(ret => {
                        if (ret) {
                            this.detail.unitId = ret.unitId
                            this.detail.unitName = ret.unitName
                        }
                    })
            },

            submit() {
                if (this.deviceId == null) {
                    this.$toast.loading("正在处理中...");
                    const data = {source: this.source, ...this.detail,}
                    if (this.isTask) data.prospectTaskId = this.$route.params.prospectTaskId
                    this.$http.tokiot.safety.danger.create(data)
                        .then(res => {
                            this.$toast.clear();
                            if (res) {
                                this.$toast.success("创建成功");
                                setTimeout(() => {
                                    this.$router.history.go(-1);
                                }, 500);
                            }
                        })
                } else {
                    this.$toast.loading("正在处理中...");
                    this.$http.tokiot.safety.danger.update(this.detail)
                        .then(res => {
                            this.$toast.clear();
                            if (res) {
                                this.$toast.success("修改成功");
                                setTimeout(() => {
                                    this.$router.history.go(-1);
                                }, 500);
                            }
                        })
                }
            },
            imageChange(imageList) {
                this.detail.fieldList = imageList;
            },
        },
    }
</script>

<style>

</style>